/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVlastnostTypDokumentu extends GContentBase<SeznamAdmVlastnostTypDokumentuObj> {
        private seznamObj: SeznamAdmVlastnostTypDokumentuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVlastnostTypDokumentuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVlastnostTypDokumentu",
                contentCaption: "jres:33000478", //RC 33000478 : Typy dokument� nav�zan� na vlastnosti
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ico} - {ixs_typ} - {ixs}"
                },
                gridSettings: {
                    columnOrder: "ixs_typ_txt,typ_vps_txt,ixs_txt,dat_zmena,zmenu_provedl",
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVlastnostTypDokumentuObj extends GAdmSeznamBase {
        private ixs_typ: string;
        private ico: string;
        private ixs: string;
        private typ_vps: number;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnostTypDokumentu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVlastnostTypDokumentu",
                newRecord: isNew,
                ixs_typ: isNew == true ? ((this.ixs_typ) ? this.ixs_typ : null) : data.ixs_typ,
                ixs: isNew == true ? ((this.ixs) ? this.ixs : null) : data.ixs,
                ico: isNew == true ? ((this.ico) ? this.ico : null) : data.ico,
                typ_vps: isNew == true ? ((this.typ_vps) ? this.typ_vps : null) : data.typ_vps
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*", "actNewDetail*", "actAddToComparison*",
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            if (this.typ_vps != null && this.typ_vps != undefined) {
                switch (this.typ_vps) {
                    case 0:
                        this.filterForm.addRow("jres:29802650").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                            name: "ixs",
                            model: "model.ixs=value.ixs_pro",
                            disabled: this.typ_vps != null && this.typ_vps != undefined ? true : false,
                            dropdown: true
                        })
                        break;
                    case 10:
                        this.filterForm.addRow("jres:29802692").addField("gselectbox", Gordic.Prefabs.Select.ginsstv(), {
                            name: "ixs",
                            model: "model.ixs=value.ixs_stv",
                            disabled: this.typ_vps ? true : false,
                            dropdown: true
                        })
                        break;
                    case 20:
                        this.filterForm.addRow("jres:29932128").addField("gselectbox", Gordic.Prefabs.Select.ginsvla(), {
                            name: "ixs",
                            model: "model.ixs=value.ixs_vla",
                            disabled: this.typ_vps ? true : false,
                            dropdown: true
                        })
                        break;
                }
            }
            this.filterForm.addRow("jres:32131067").addField("gselectbox", Gordic.Prefabs.Select.sslstyp(), {
                name: "ixs_typ",
                model: "model.ixs_typ=value.ixs_typ",
                disabled: this.ixs_typ ? true : false,
                dropdown: true
            }).addRow("jres:32131046").addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                name: "ico",
                model: "model.ico=value.ico",
                disabled: this.ico ? true : false,
                dropdown: true
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs)
                hardFilter["ixs"] = this.ixs;
            if (this.ixs_typ)
                hardFilter["ixs_typ"] = this.ixs_typ;
            if (this.ico)
                hardFilter["ico"] = this.ico;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs)
                data["ixs"] = this.ixs;
            if (this.ixs_typ)
                data["ixs_typ"] = this.ixs_typ;
            if (this.ico)
                data["ico"] = this.ico;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVlastnostTypDokumentu.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.ixs_typ, data.ixs, data.ico),
                nazev: ""
            }
        }
    }
}